document.addEventListener('DOMContentLoaded', function () {
  var cartContainer = document.querySelector('.cart-container-desktop');
  var cartIcon = document.querySelector('.cart-container-desktop a.icon-bag.mini_cart.dropdown_link');

  if (!cartContainer || !cartIcon) return;

  function openCartPopup() {
    cartContainer.classList.add('cart-click-open');
  }

  function closeCartPopup() {
    cartContainer.classList.remove('cart-click-open');
  }

  cartIcon.addEventListener('click', function (e) {
    e.preventDefault();

    if (cartContainer.classList.contains('cart-click-open')) {
      closeCartPopup();
    } else {
      openCartPopup();
    }
  });

  document.addEventListener('click', function (e) {
    if (!cartContainer.contains(e.target)) {
      closeCartPopup();
    }
  });

  var addToCartButtons = document.querySelectorAll(
    'form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] input[type="submit"], button[name="add"], .add_to_cart'
  );

  addToCartButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      setTimeout(function () {
        openCartPopup();
      }, 900);
    });
  });
});